import KeysContext from "contexts/KeysContext";
import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";
import styles from "./styles.module.scss";
import usePDF from "hooks/usePDF";
import { axiosInstance } from "api/axios";
import { IKey } from "dto/IKey";
import { ItemKind } from "dto/IKindItems";
import PDFViewer from "components/PDFViewer";

const DocumentViewModule = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const PDFId = queryParams.get("pdf");
  const {
    attachmentUri,
    blob,
    removeBlob,
    decryptPackageAndSetBlob,
    downloadCourtPortalPdf,
  } = usePDF();
  const { keys, setKeys } = useContext(KeysContext);

  const getKey = async (keyId: string): Promise<IKey> => {
    const response = await axiosInstance.get(`/keys/object?id=${keyId}`);
    return response.data;
  };

  useEffect(() => {
    const handleFetchKeys = async () => {
      if (!PDFId) return;
      const splittedPDFId = PDFId.split(":");
      const fileEncryptionKey = splittedPDFId[4];

      if (fileEncryptionKey && fileEncryptionKey !== "null") {
        const encryptionKey = await getKey(fileEncryptionKey);
        let parentKeyId: IKey | null = null;

        if (encryptionKey?.ParentPrivateKey) {
          parentKeyId = {
            Id: encryptionKey.ParentKeyId,
            Armored: null,
            Initial: false,
            ParentKeyId: null,
            PrivateKey: encryptionKey?.ParentPrivateKey,
            PublicKey: "",
          };
        }

        setKeys([encryptionKey, parentKeyId].flat());
      }
    };

    handleFetchKeys();
  }, [PDFId, location, setKeys]);

  useEffect(() => {
    const splittedPDFId = PDFId.split(":");

    const fileEncryptionKey = splittedPDFId[4];

    if (
      (fileEncryptionKey && fileEncryptionKey !== "null" && !keys.length) ||
      !PDFId
    )
      return;
    if (blob) removeBlob();

    const packId = splittedPDFId[0];
    const fileName = splittedPDFId[1];
    const fileUri = splittedPDFId[2];
    const fileKind = splittedPDFId[3];

    if (attachmentUri === fileUri) return;

    if (
      Number(fileKind) === ItemKind.CourtPortalDeliveranceDocument ||
      Number(fileKind) === ItemKind.CourtPortalDeliverance ||
      Number(fileKind) === ItemKind.CourtPortalDocument
    ) {
      downloadCourtPortalPdf(fileUri ?? packId);
    }

    decryptPackageAndSetBlob({
      FileName: fileName,
      EncryptionKeyId: fileEncryptionKey,
      Uri: fileUri,
      Kind: Number(fileKind),
    });
  }, [PDFId, location, keys, attachmentUri]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <PDFViewer showHeader={true} file={blob} showCloseButton={false} />
      </div>
    </div>
  );
};

export default DocumentViewModule;
